import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { Api } from "../api";
import { PosmItem } from "../../models/posm-item.model";

@Injectable()
export class PosmItemProvider extends Api {

  constructor(public http: HttpClient) {
    super(http);
  }

  getByID(id: number): Observable<PosmItem> {
    return this.http
      .get<PosmItem>(`${this.url}/posm-items/${id}`)
      .map(response => {
        return new PosmItem(response);
      })
      .catch(this.handleError)
  }

  getByPosmCategoryID(posmCategoryID: number): Observable<PosmItem[]> {
    return this.http
      .get<PosmItem[]>(`${this.url}/posm-items/${posmCategoryID}/posm-category`)
      .map(response => {
        return response.map((posmItem) => new PosmItem(posmItem));
      })
      .catch(this.handleError);
  }

  /*getChildrenByID(id: number, withPosms: boolean): Observable<PosmItem[]> {
    return this.http
      .get<PosmItem[]>(`${this.url}/posm-items/${id}/children/${withPosms ? 'posms' : ''}`)
      .map(response => {
        return response.map((posmItem) => new PosmItem(posmItem));
      })
      .catch(this.handleError)
  }*/

  getAll(): Observable<PosmItem[]> {
    return this.http
      .get<PosmItem[]>(`${this.url}/posm-items`)
      .map(response => {
        return response.map((posmItem) => new PosmItem(posmItem));
      })
      .catch(this.handleError);
  }

}



// WEBPACK FOOTER //
// ./src/providers/posm-item/posm-item.ts